import React from 'react';
import CourseHighlights from '../../Shared/Courses/CourseHighlights';
import CourseOperate from '../../Shared/Courses/CourseOperate';

const InternetThings = () => {
    return (
        <div className='px-4 md:px-12 pt-10'>
            <h4 className='text-blue-500 text-xl'>Certified Online Course</h4>
            <h1 className='text-blue-500 text-4xl font-semibold my-4'>Internet of <span className='text-orange-400'>Things</span></h1>
            <h1 className='text-4xl font-semibold my-4'>Course @ Rs. 1199</h1>
            <h2 className=''>To create prediction models or a modern life learn Internet of things.</h2>
            <h3 className='text-xl my-4 font-semibold'>8 Weeks, 45 min /day (3 Recorded+2 Live)</h3>
            <h5>Offer: Get flat Rs.200 off oby applying the promo code CAREERHikers</h5>
            <h1 className='text-5xl mt-4 font-bold'>Download the</h1>
            <h1 className='text-5xl mt-2 text-orange-500 font-bold'><span className='text-blue-500'>APP</span> Now!</h1>
            <CourseHighlights />
            <div className='flex mb-8 mt-12'>
                <div className='flex-1 md:mr-4'>
                    <h1 className='text-3xl font-semibold mb-6'>Why Learn Internet of things?</h1>
                    <h2 className='text-xl my-2'>Publish your concept to the masses</h2>
                    <p>Google searches, YouTube recommendations, and Uber's surge pricing Internet of things is already widely utilised in daily life, and this trend will continue.</p>
                    <h1 className='text-2xl my-2'>Be in demand</h1>
                    <h3>According to Glassdoor, the average pay for Internet of things positions is 11LPA+.</h3>
                    <h1 className='text-xl my-2'>Create the future</h1>
                    <p className='text-sm'>The future belongs to Internet of things, whether it's self-driving vehicles or robots that act and speak like people.</p>
                </div>
                <img className='flex-1' src='' alt="" />
            </div>
            <CourseOperate />
        </div>
    );
};

export default InternetThings;